import { Index } from "components/ContactUs/Index";

export const ContactUs = () => {
  return <Index />;
};
